import React, { useState, useEffect } from 'react';
import { parsePrice } from '@utils/price-helpers';
import { useDispatch, useSelector } from 'react-redux';
import { addItem, setIsLoading } from '@features/cart/cartSlice';
import { addItemToCart, checkForLineItem } from '@utils/shopify-helpers';
import styles from './RecommendationUpsell.module.scss';

const RecommendationUpsell = ({ recommendation, bundleKey, lozengeMessage, addlInfo, itemGroupKey, shipmentInfo }) => {
	const isAvailable = recommendation.available;

	const { featured_variant = false } = recommendation;
	const variantId = featured_variant ? featured_variant.id : recommendation.variants[0].id;
	const copy = addlInfo ?? recommendation.description;

	const dispatch = useDispatch();
	const allItems = useSelector(state => state.cart.items);

	const [isUpsellAdded, setIsUpsellAdded] = useState(checkForLineItem(allItems, variantId));

	const addUpsellAndUpdateCart = async ({ variantId, quantity, bundleKey, itemGroupKey }) => {
		dispatch(setIsLoading({ value: true, key: itemGroupKey }));
		const response = await addItemToCart({ variantId, quantity, bundleKey, product: recommendation });

		if (response.status === UNPROCESSABLE_ENTITY) {
			return;
		}

		const addedItem = response.items[0];
		setIsUpsellAdded(true);
		dispatch(addItem({ newItem: { ...addedItem } }));
	};

	useEffect(() => {
		setIsUpsellAdded(checkForLineItem(allItems, variantId));
	}, [allItems]);

	return (
		<div
			className={`col-12 cart-item cart-item__addon upsell item-${variantId} upsell-${bundleKey} ${styles.recommendationUpsellContainer}`}
		>
			<div className='h-100 align-items-center d-flex flex-grow-1 justify-content-start'>
				<div className='item-image align-self-center cart-item__image'>
					<img
						className='img-fluid h-100 mx-auto d-block'
						src={featured_variant ? featured_variant.featured_image.src : recommendation.featured_image}
						data-id={recommendation.id}
					/>
				</div>
				<div
					className={`pl-3 h-100 d-flex flex-grow-1 flex-column justify-content-lg-between align-items-lg-start ${styles.upsellContent}`}
				>
					<div className={`text-left cart-item__title h-100 ${styles.lozengeMessage}`}>
						{lozengeMessage ? `<div class='label flag'>{lozengeMessage}</div>` : ``}
						<div className={`mb-1 ${styles.title}`}>
							<p className='m-0 title cart-title-flex'>{recommendation.title}</p>
						</div>
						{shipmentInfo ? `<div class='label red-text'>{shipmentInfo}</div>` : ``}

						<div className='p'>{copy}</div>
					</div>

					<div className={`add-control h-100 mt-2 d-flex flex-column justify-content-end align-self-end`}>
						<div
							className={`pair-btn--sm pair-btn__full-width pair-btn__secondary ${
								isUpsellAdded ? 'justify-content-center' : 'justify-content-between'
							} ${isAvailable ? '' : 'sold-out'} ${styles.addButton}`}
							onClick={() => {
								if (isUpsellAdded) return;
								addUpsellAndUpdateCart({ variantId, quantity: 1, bundleKey, itemGroupKey });
							}}
							data-product={JSON.stringify(recommendation)}
							data-cart-add={recommendation.variants[0].name}
							data-name={recommendation.title}
							data-variant-id={variantId}
						>
							{isUpsellAdded ? 'In Cart!' : isAvailable ? '+Add' : 'Sold Out'}
							{isAvailable && !isUpsellAdded && (
								<span className='upsell'>${Number(parsePrice(recommendation.price, 0))}</span>
							)}
						</div>
					</div>
				</div>
			</div>
			<div className={`d-flex flex-grow-0 align-items-center delete-control`}>
				<svg className='mx-2' width='1' height='16' viewBox='0 0 1 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
					<line x1='0.5' y1='2.18557e-08' x2='0.499999' y2='16' stroke='#9B9A9A' />
				</svg>
				<div
					className={`button item-price flex-fill align-self-center cart-item__quant item-price-${recommendation.variants[0].id}`}
				>
					${parsePrice(recommendation.price)}
				</div>
			</div>
		</div>
	);
};

export default RecommendationUpsell;
